// extracted by css-extract-rspack-plugin
export default {"other-offers":"other-offers-ZWtTjY","otherOffers":"other-offers-ZWtTjY","other-offers__heading":"other-offers__heading-ns_pNy","otherOffersHeading":"other-offers__heading-ns_pNy"};